<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>用户账单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <!-- <el-tabs :value="billType" @tab-click="handleTabChange">
        <el-tab-pane label="所有" name="all"></el-tab-pane>
        <el-tab-pane
          v-for="type in billTypes"
          :key="type.value"
          :label="type.label"
          :name="type.value"
        ></el-tab-pane>
      </el-tabs>-->
      <div class="page-actions">
        <el-select v-model="billType" placeholder="账单类型">
          <el-option label="所有账单类型" value></el-option>
          <el-option
            v-for="type in billTypes"
            :key="type.value"
            :label="type.label"
            :value="type.value"
          ></el-option>
        </el-select>
        <el-select v-model="coinType" placeholder="请选择币种">
          <el-option label="所有币种" value></el-option>
          <el-option
            v-for="coin in coinTypeList"
            :label="coin"
            :value="coin"
            :key="coin"
          ></el-option>
        </el-select>
        <el-input placeholder="请输入账号ID" clearable v-model="uid">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>

        <el-date-picker
          type="daterange"
          v-model="timeRange"
          start-placeholder="起始时间"
          end-placeholder="终止时间"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <el-radio-group v-model="detailMode" size="mini">
          <el-radio-button label="desc">文字描述</el-radio-button>
          <el-radio-button label="detail">原始数据</el-radio-button>
          <el-radio-button label="focus" :disabled="!uid"
            >专注用户</el-radio-button
          >
        </el-radio-group>
        <!-- <el-switch v-model="isDetailMode"  active-text="详情模式 " inactive-text="专注模式">       
        </el-switch>-->
        <a :href="downloadLink" target="_blank" v-if="this.billType === 'all'"
          >导出Excel</a
        >
      </div>
      <div
        :style="{
          color: 'red',
          paddingBottom: '10px',
          borderBottom: '1px solid #ddd'
        }"
      >
        <span>*</span>
        如需查询2个月以前的数据，请选择具体时间范围
      </div>
      <bill-list
        :uid="uid"
        :detailMode="detailMode"
        @refresh="getList"
      ></bill-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import BillList from './components/list';
import moment from 'moment';
import qs from 'qs';

const TIME_RANGE = [
  new Date(
    moment()
      .subtract(10, 'day')
      .startOf('day')
      .valueOf()
  ),
  new Date(
    moment()
      .add(1, 'day')
      .startOf('day')
  )
];

export default {
  name: 'UserBill',
  data() {
    return {
      uid: undefined,
      coinType: '',
      timeRange: TIME_RANGE,
      detailMode: 'desc',
      billType: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '9月1日至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(new Date('2019-09-01 00:00:00'));
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  components: {
    BillList
  },
  computed: {
    ...mapState('userBill', ['coinTypeList', 'pagination', 'billTypes']),
    downloadLink() {
      const data = {
        uid: this.uid,
        billType: this.billType,
        coinType: this.coinType,
        from:
          this.timeRange && this.timeRange[0]
            ? this.timeRange[0].getTime()
            : undefined,
        to:
          this.timeRange && this.timeRange[1]
            ? this.timeRange[1].getTime()
            : undefined
      };
      const params = qs.stringify(data);
      return `/la/admin/user/bill/export?${params}`;
    }
  },
  watch: {
    coinType(val, oldval) {
      if (val != oldval) {
        this.coinType = val;
        this.getList({ page: 1 });
      }
    },
    billType(val, oldval) {
      if (val != oldval) {
        this.billType = val;
        this.getList({ page: 1 });
      }
    }
  },
  methods: {
    ...mapActions('userBill', [
      'listCoinType',
      'listBillType',
      'reqBills',
      'listAccountType'
    ]),
    ...mapMutations('userBill', ['changeTab', 'setBillList', 'setPagination']),
    handleSearch() {
      this.getList({ page: 1 });
    },
    handleTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({ page: 1 });
    },
    getList(data = {}) {
      if (!this.uid) {
        this.$message.error('请输入用户ID');
        return;
      }
      this.reqBills({
        uid: this.uid,
        billType: this.billType,
        coinType: this.coinType,
        from:
          this.timeRange && this.timeRange[0]
            ? moment(this.timeRange[0])
                .startOf('day')
                .valueOf()
            : undefined,
        to:
          this.timeRange && this.timeRange[1]
            ? moment(this.timeRange[1])
                .endOf('day')
                .valueOf()
            : undefined,
        ...this.pagination,
        ...data
      }).then(() => {
        if (!this.uid && this.detailMode === 'focus') {
          this.detailMode = 'desc';
        }
      });
    }
  },
  created() {
    this.setBillList([]);
    this.setPagination({
      page: 1,
      size: 25
    });
    this.changeTab('all');
    this.listCoinType();
    this.listBillType();
    this.listAccountType();
    // this.getList();
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
</style>
